import { useTranslation } from 'react-i18next';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'he' ? 'en' : 'he';
    i18n.changeLanguage(newLang);
    
    // Update document direction and lang attribute
    document.documentElement.dir = newLang === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg text-white text-sm font-medium hover:bg-white/20 transition-all duration-300 hover:scale-105"
      aria-label="Toggle language"
    >
      <span className="text-lg">
        {i18n.language === 'he' ? '🇺🇸' : '🇮🇱'}
      </span>
      <span className="hidden sm:inline language-toggle">
        {i18n.language === 'he' ? 'English' : 'עברית'}
      </span>
    </button>
  );
};

export default LanguageToggle; 